import { render } from "./Timer.vue?vue&type=template&id=7ea80497"
import script from "./Timer.vue?vue&type=script&lang=ts"
export * from "./Timer.vue?vue&type=script&lang=ts"
script.render = render

export default script